import api from '../api';

import CrmSyncActions from 'actions/crm/CrmSyncActions';

/**
 * CrmSyncAccountAndOpportunitiesSource implements interactions with account-and-opportunities endpoints which return
 * one account and multiple opportunities for a given contact-account-id
 */
const CrmSyncAccountAndOpportunitiesSource = {
  findAccountsAndOpportunitiesByContactName: {
    remote(state, contactName) {
      const config = {baseURL: '/apiv2/crm'};
      const data = {contact: contactName};
      return api.post(`/accounts_and_opportunities`, data, config);
    },
    loading: CrmSyncActions.findAccountsAndOpportunitiesByContactNameLoading,
    success: CrmSyncActions.findAccountsAndOpportunitiesByContactNameSuccess,
    error: CrmSyncActions.findAccountsAndOpportunitiesByContactNameError,
  },
};

export default CrmSyncAccountAndOpportunitiesSource;
